const LOW_ABUNDANCE_THRESHOLD = 3;

/**
 * a search result page with thin content should not be indexed, we call this "low abundance"
 */
export const hasAbundance = (itemCount: number) =>
  itemCount > LOW_ABUNDANCE_THRESHOLD;
